import { useState, useCallback, useRef } from 'react';
const useCsvParse = () => {
    const [result, setResult] = useState(null);
    const [source, setSource] = useState(null);
    const parseGeneration = useRef(0);
    const parse = useCallback((text, skipHeader) => {
        const lines = text
            .split(/\r?\n/)
            .map((l) => l.trim())
            .filter(Boolean);
        const rows = skipHeader ? lines.slice(1) : lines;
        setResult({
            rows,
            totalCount: rows.length,
            preview: rows.slice(0, 5)
        });
    }, []);
    const parseFile = useCallback((file, skipHeader) => {
        const generation = ++parseGeneration.current;
        setResult(null);
        setSource('file');
        const reader = new FileReader();
        reader.onload = (e) => {
            if (generation !== parseGeneration.current)
                return;
            const text = e.target?.result;
            parse(text, skipHeader);
        };
        reader.readAsText(file);
    }, [parse]);
    const parseText = useCallback((text, skipHeader) => {
        parseGeneration.current += 1;
        setResult(null);
        setSource('text');
        parse(text, skipHeader);
    }, [parse]);
    const reset = useCallback(() => {
        parseGeneration.current += 1;
        setResult(null);
        setSource(null);
    }, []);
    return {
        result,
        source,
        parseFile,
        parseText,
        reset
    };
};
export default useCsvParse;
